var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "url(#paint0_linear_16412_3001)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.02098 15.6171C5.99167 15.7188 6.02098 15.8301 6.09516 15.9043C6.14988 15.9589 6.22613 15.9902 6.30229 15.9902C6.32962 15.9902 6.35702 15.9863 6.38243 15.9785L9.11375 15.1992L6.80051 12.8867L6.02098 15.6171Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30146 16C6.22132 16 6.14515 15.9687 6.08853 15.9121C6.01037 15.834 5.98107 15.7207 6.01228 15.6153L6.79769 12.8691L9.13444 15.2051L6.3835 15.9883C6.35618 15.9961 6.32878 16 6.30146 16ZM6.80555 12.9043L6.02991 15.6192C6.00251 15.7188 6.02991 15.8242 6.10219 15.8965C6.15492 15.9492 6.2272 15.9785 6.30146 15.9785C6.32687 15.9785 6.35419 15.9746 6.37961 15.9668L9.09536 15.1915L6.80555 12.9043Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7354 7.5078L14.4948 6.26756C14.3268 6.10155 14.108 6.00977 13.8715 6.00977C13.6371 6.00977 13.4163 6.10155 13.2502 6.26566L12.6289 6.88669L15.1122 9.36914L15.7335 8.74803C15.8996 8.58202 15.9894 8.3613 15.9894 8.12692C15.9914 7.89255 15.8996 7.67381 15.7354 7.5078Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1141 9.3828L12.6172 6.88669L13.2443 6.25978C13.4124 6.09178 13.6351 6 13.8715 6C14.1098 6 14.3326 6.09178 14.4987 6.25978L15.7393 7.50002C15.9073 7.66794 15.9991 7.89064 15.9991 8.12692C15.9991 8.36526 15.9073 8.58789 15.7393 8.75391L15.1141 9.3828ZM12.6445 6.88669L15.1141 9.35548L15.7276 8.74216C15.8917 8.57812 15.9816 8.3613 15.9816 8.12891C15.9816 7.89651 15.8917 7.67969 15.7276 7.51566L14.4869 6.27344C14.3229 6.10941 14.104 6.01953 13.8715 6.01953C13.639 6.01953 13.4221 6.10941 13.258 6.27344L12.6445 6.88669Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12891 12.3872L12.217 7.30078L14.701 9.78392L9.61288 14.8704L7.12891 12.3872Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61214 14.8848L7.11328 12.3867L12.2165 7.28711L14.7135 9.78322L9.61214 14.8848ZM7.14259 12.3867L9.61214 14.8555L14.6861 9.78322L12.2165 7.3145L7.14259 12.3867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16412_3001",
    x1: -9.57622,
    y1: 12.1477,
    x2: 11.7438,
    y2: 32.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3682F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ad780cb1af60140f911696be0195fd7d.svg";
export { ForwardRef as ReactComponent };